/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Sign_InInputs */

const en_landing_studio_sign_in = /** @type {(inputs: Landing_Studio_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to generate`)
};

const zh_landing_studio_sign_in = /** @type {(inputs: Landing_Studio_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后生成`)
};

/**
* | output |
* | --- |
* | "Sign in to generate" |
*
* @param {Landing_Studio_Sign_InInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_sign_in = /** @type {((inputs?: Landing_Studio_Sign_InInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Sign_InInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_sign_in(inputs)
	return zh_landing_studio_sign_in(inputs)
});
export { landing_studio_sign_in as "landing.studio.sign_in" }